const Experience = () => {
    return(
        <div className='skills-container'>
            <section className='exp-content-container' id="exp">

                <h2>WORK EXPERIENCE</h2>
                
                <div className='exp-row'>
                    <p className='job-title'><b>Software Developer @ Citi</b></p>
                    <p>May 2025 - Aug 2025</p>
                </div>

            </section>
        </div>
    );
}

export default Experience;
